import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { EncryptionConfigService } from './encryption-config.service';
import { EncryptionConfig } from './encryption.model';
import { EncryptionService } from './encryption.service';

export function onEncryptionModuleInitialize(service: EncryptionService): any {
    return () => service.initialize();
}

@NgModule()
export class EncryptionModule {
    static forRoot(config: EncryptionConfig): ModuleWithProviders<EncryptionModule> {
        return {
            ngModule: EncryptionModule,
            providers: [
                EncryptionService,
                {
                    provide: EncryptionConfigService,
                    useValue: config
                },
                {
                    provide: APP_INITIALIZER,
                    useFactory: onEncryptionModuleInitialize,
                    deps: [EncryptionService],
                    multi: true
                }
            ]
        };
    }
}
